import React from 'react';
import MagicEightBall from '../../Artwork/MagicEightBall';
import styles from './questionsArtwork.css';

const QuestionsArtwork = () => {
  return (
    <div>
      <div className={styles.eightBall}>
        <MagicEightBall color="var(--purpleBright)" type="ball" />
      </div>
      <div className={styles.eightBallMessage}>
        <MagicEightBall color="var(--purpleBright)" type="message" />
      </div>
    </div>
  );
};

export default QuestionsArtwork;
